import { Badge } from "@/components/ui/badge";
import { parsePrTypes } from "@trainrr/api/exercise-prs";
import { Medal } from "lucide-react";
import { PR_MEDAL_COLOR, prTypeLabel } from "./prDisplay";

type Props = {
  types?: unknown;
};

export function PrTypeBadges({ types }: Props) {
  const prTypes = parsePrTypes(types);
  if (prTypes.length === 0) {
    return null;
  }

  return (
    <div className="flex min-w-0 flex-wrap items-center gap-1.5">
      {prTypes.map((type) => (
        <Badge
          key={type}
          variant="outline"
          className="gap-1 border-amber-500/30 bg-amber-500/10 pl-1.5 font-medium text-amber-800 hover:bg-amber-500/10 dark:text-amber-200"
        >
          <Medal
            className="size-3.5 shrink-0"
            color={PR_MEDAL_COLOR}
            fill={PR_MEDAL_COLOR}
          />
          {prTypeLabel(type)}
        </Badge>
      ))}
    </div>
  );
}
